// Veronne cart: the Upgrade button in the cart switches to the next bundle and adds that bundle's free gifts.
// Loaded on every page from layout/theme.liquid, so it also works after an add-to-cart that didn't reload the page.
if (!window.__vUpgradeBound) {
      window.__vUpgradeBound = true;
      document.addEventListener('click', async (event) => {
        const btn = event.target.closest('[data-v-upgrade-btn]');
        if (!btn) return;
        const card = btn.closest('[data-v-upgrade]');
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        try {
          const updates = { [card.dataset.old]: 0, [card.dataset.new]: Number(card.dataset.newQty) };
          const gifts = (card.dataset.gifts || '').split(',').filter(Boolean);
          if (gifts.length) {
            const cart = await (await fetch('/cart.js')).json();
            gifts.forEach((id) => {
              const line = cart.items.find((i) => String(i.variant_id) === id);
              updates[id] = Math.max(line ? line.quantity : 0, 1);
            });
          }
          const res = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates }),
          });
          if (!res.ok) throw new Error('cart update ' + res.status);
          const items = document.querySelector('cart-items-component[data-section-id]');
          const { sectionRenderer } = await import('@theme/section-renderer');
          if (items) await sectionRenderer.renderSection(items.dataset.sectionId, { cache: false, mode: 'hydration' });
          document.querySelectorAll('cart-icon').forEach((icon) => icon.ensureCartBubbleIsCorrect?.());
        } catch (error) {
          console.warn('[veronne] upgrade failed', error);
          window.location.href = '/cart';
        }
      });
    }

// Horizon pins the cart summary (with the checkout button) when it is at most half the drawer, but it measures when the
// drawer opens. After the first add from an empty cart that is before the items arrive, so on short phones the button
// scrolled away below them. Measure again, the same way, each time the drawer content is re-rendered.
if (!window.__vStickyBound) {
  window.__vStickyBound = true;
  const dialog = document.querySelector('#cart-drawer dialog');
  let queued = false;
  const measure = () => {
    queued = false;
    const summary = dialog.querySelector('.cart-drawer__summary');
    const drawerHeight = dialog.getBoundingClientRect().height;
    if (!summary || !drawerHeight) return;
    dialog.setAttribute('cart-summary-sticky', summary.getBoundingClientRect().height / drawerHeight > 0.5 ? 'false' : 'true');
  };
  if (dialog) new MutationObserver(() => { if (!queued) { queued = true; requestAnimationFrame(measure); } }).observe(dialog, { childList: true, subtree: true });
}
